import { ReactNode } from 'react';
import { VisuallyHidden } from '@mantine/core';

export function ScreenReaderOnly({ children }: { children: ReactNode }) {
  return <VisuallyHidden>{children}</VisuallyHidden>;
}
